// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Moment from "moment";
import * as MomentRe from "../../node_modules/bs-moment/src/MomentRe.bs.js";

var defaultFormat = "DD-MM-YYYY HH:mm";

function now(param) {
  return new Date(Date.now());
}

function toMoment(date) {
  return Moment(date);
}

function fromMoment(moment) {
  return moment.toDate();
}

function toString(formatOpt, date) {
  var format = formatOpt !== undefined ? formatOpt : defaultFormat;
  return Moment(date).format(format);
}

function momentWithFormat(date, format) {
  return Moment(date, format);
}

function fromString(formatOpt, dateString) {
  var format = formatOpt !== undefined ? formatOpt : defaultFormat;
  return Moment(dateString, format).toDate();
}

function toSecond(date) {
  return Moment.duration(toString("HH:mm:ss", date)).asSeconds() | 0;
}

function toMinute(date) {
  return Moment.duration(toString("HH:mm", date)).asMinutes() | 0;
}

function fromTimeStamp(timestamp) {
  return MomentRe.momentWithUnix(timestamp).toDate();
}

function toTimeStamp(date) {
  return Moment(date).unix();
}

function isSame(firstDate, secondDate) {
  return Moment(firstDate).isSame(Moment(secondDate));
}

function isAfter(firstDate, secondDate) {
  return Moment(firstDate).isAfter(Moment(secondDate));
}

function isBefore(firstDate, secondDate) {
  return Moment(firstDate).isBefore(Moment(secondDate));
}

function getDateTimeAfterElapsedTime(elapsedTime, timeUnit, initialDate) {
  var toDuration = Moment.duration(elapsedTime, timeUnit);
  return MomentRe.Moment.add(toDuration, Moment(initialDate)).toDate();
}

function tomorrow(param) {
  return getDateTimeAfterElapsedTime(1, "days", new Date(Date.now()));
}

function getYesterday(param) {
  return getDateTimeAfterElapsedTime(-1, "days", new Date(Date.now()));
}

function calculateEndDate(endTime, format) {
  var effectiveTillYear = endTime.getFullYear() | 0;
  if (effectiveTillYear >= 3100) {
    return "Lifetime";
  } else {
    return toString(format, endTime);
  }
}

function diffDates(startDate, endDate, timeUnit) {
  return Moment(endDate).diff(Moment(startDate), timeUnit);
}

function startOf(date, scale) {
  return MomentRe.Moment.startOf(scale, Moment(date)).toDate();
}

function endOf(date, scale) {
  return MomentRe.Moment.endOf(scale, Moment(date)).toDate();
}

function toUtc(date) {
  return MomentRe.momentUtc(undefined, date).toDate();
}

function isValid(date) {
  return Moment(date).isValid();
}

function format(date, format$1) {
  return Moment(date).format(format$1);
}

function day(date) {
  return Moment(date).day();
}

var largeYear = 3100;

export {
  largeYear ,
  defaultFormat ,
  now ,
  toMoment ,
  fromMoment ,
  toString ,
  momentWithFormat ,
  fromString ,
  toSecond ,
  toMinute ,
  fromTimeStamp ,
  toTimeStamp ,
  isSame ,
  isAfter ,
  isBefore ,
  getDateTimeAfterElapsedTime ,
  tomorrow ,
  getYesterday ,
  calculateEndDate ,
  diffDates ,
  startOf ,
  endOf ,
  toUtc ,
  isValid ,
  format ,
  day ,
  
}
/* moment Not a pure module */
